<div id="layout-wrapper">
  <app-client-navbar></app-client-navbar>

  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content">
    <div class="page-content">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- End Page-content -->

    <app-footer></app-footer>
  </div>
  <!-- end main content-->
</div>
<!-- END layout-wrapper -->